import axios from "axios";
import * as localforage from "localforage";
import Noty from "noty";
import { goUrl } from "./apiSetup";
import { t } from "../langs/useTranslation";
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/relax.css";
import { errorHandling } from "@/helpers/errorHandling";
import requestRetry from "./requestRetry";
import { setToken } from "@/apis/getToken";
import { setPermissions } from "@/apis/getPermisions";
import { setCurrentCompanyId } from "@/apis/getCurrentCompanyId";
import { authLogout } from "@/apis/logoutAPI";
import { setUserInfo } from "./getUserInfo";

export function toast(options) {
  return new Noty({
    theme: "relax",
    type: "error",
    layout: "topRight",
    closeWith: ["click", "button"],
    timeout: 3000,
    ...options
  }).show();
}

toast.closeAll = () => {
  Noty.closeAll();
};

toast.success = (msg, callbacks = {}) => {
  return toast({
    type: "success",
    text: msg,
    callbacks
  });
};

toast.error = (msg, callbacks = {}) => {
  return toast({
    type: "error",
    text: msg || "Unknown Error",
    callbacks
  });
};

toast.info = (msg, callbacks = {}) => {
  return toast({
    type: "info",
    text: msg,
    callbacks
  });
};

toast.warning = (msg, callbacks = {}) => {
  return toast({
    type: "warning",
    text: msg,
    callbacks
  });
};

toast.alert = (msg, callbacks = {}) => {
  // return toast({
  //   type: "alert",
  //   text: msg,
  //   callbacks
  // });
  const n = toast({
    type: "alert",
    layout: "center",
    timeout: false,
    text: msg,
    closeWith: [],
    callbacks,
    animation: {
      open: "noty_alert_effects_open",
      close: "noty_alert_effects_close"
    },
    buttons: [
      Noty.button("OK", "noty_button", () => {
        n.close();
      })
    ]
  });
  return n;
};

toast.confirm = (msg, callbacks = {}) => {
  const n = toast({
    type: "alert",
    layout: "center",
    timeout: false,
    text: msg,
    closeWith: [],
    callbacks,
    animation: {
      open: "noty_alert_effects_open",
      close: "noty_alert_effects_close"
    },
    buttons: [
      Noty.button("confirm", "noty_button success", () => {
        callbacks.onConfirm?.();
        n.close();
      }),
      Noty.button("OK", "noty_button", () => {
        callbacks.onCancel?.();
        n.close();
      })
    ]
  });
  return n;
};

export function getErrorMsg(code) {
  const ERROR_CODE_MSG = {
    0: t({ defaultMessage: "未知错误" }),
    16: t({ defaultMessage: "token 失效" }),
    30000: t({ defaultMessage: "参数错误" }),
    40000: t({ defaultMessage: "用户没有绑定邮箱，无法进行验证" }),
    40001: t({ defaultMessage: "请勿频繁发送验证码！" }),
    40002: t({ defaultMessage: "验证失败" })
  };
  return ERROR_CODE_MSG[code];
}

export const request = requestRetry(
  axios.create({
    // baseURL: goUrl + "/fec"
  })
);

let timer;
const origHttpGet = request.get;
const origHttpDelete = request.delete;

// 重写get方法，保持跟post方法传参一致
request.get = (url, params, config) => {
  return origHttpGet(url, { params, ...config });
};

// 重写delete方法，保持跟post方法传参一致
request.delete = (url, params, config) => {
  return origHttpDelete(url, { params, ...config });
};

request.blob = (url, params, config) => {
  return origHttpGet(url, { params, responseType: "blob", ...config });
};

request.interceptors.request.use(
  async config => {
    const token = await localforage.getItem("token");
    const companyId = await localforage.getItem("currentCompanyId");
    const lang = localStorage.getItem("rcml-lang");
    config.baseURL = goUrl + "/fec";
    config.headers.Authorization = "Bearer  " + token;
    config.headers.Accept = "application/json";
    config.headers.AcceptLanguage = lang || "en";
    //config.withCredentials = true;
    if (config.method === "get" || config.method === "delete") {
      if (!config.params) {
        config.params = {};
      }
      if (!config.params.companyId) {
        config.params.companyId = companyId;
      }
    } else {
      if (!config.data) {
        config.data = {};
      }
      if (typeof config.data === "object") {
        if (config.data instanceof FormData) {
          if (!config.data.get("companyId")) {
            config.data.append("companyId", companyId);
          }
        } else if (!config.data.companyId) {
          config.data.companyId = companyId;
        }
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    const { data = {} } = response;
    if (data.code) {
      const err = new Error(
        getErrorMsg(data.code) || data.message || "unknown error"
      );
      err.code = data.code;
      toast.error(err.message);

      if (err.code === 16) {
        setToken(null);
        setPermissions([]);
        setUserInfo({});
        setCurrentCompanyId(null);
        authLogout();
      }
      return Promise.reject(err);
    }
    return data;
  },
  err => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    timer = setTimeout(() => {
      if (err.name === "CanceledError") {
        return;
      }
      errorHandling(err);
    });

    return Promise.reject(err);
  }
);
